import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideOAuthClient } from 'angular-oauth2-oidc';
import { provideIamClient } from './core/iam';
import { routes } from './app.routes';
import { authInterceptor } from './core/auth.interceptor'; // Lab 05
import { environment as env } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    // IAM SDK: token-exchange client + session storage (see core/auth.service.ts)
    ...provideIamClient({ iamBaseUrl: env.iamBaseUrl, audience: env.audience }),
    provideHttpClient(withInterceptors([authInterceptor])), // Lab 05: attach token + handle 401
    provideOAuthClient(),
  ],
};
